import { AT_IGNORE_CARD_IDS_CLEAR } from './constants';
import { IIgnoreCardIdsClearAction } from './types';

export const ignoreCardIdsClearAction = (): IIgnoreCardIdsClearAction => ({
        type: AT_IGNORE_CARD_IDS_CLEAR
    }
);
